import React from 'react';
import { ListGroup } from 'react-bootstrap';
import { RouteComponentProps } from 'react-router-dom';
import { useGroupQuery } from '../../generated/graphql';
import routes from '../../routes/routes';

interface GroupScreenParams {
    id: string;
}

type GroupScreenProps = RouteComponentProps<GroupScreenParams>;

export const GroupScreen: React.FC<GroupScreenProps> = ({ match, history }) => {
    const id = match.params.id;
    const { data } = useGroupQuery({ variables: { id: +id || 0 } });

    const group = data?.group;

    return (
        <div>
            <h3>Назва підрозділу: {group?.name}</h3>
            <ListGroup>
                {group?.children?.map((childrenItem) => {
                    return (
                        <ListGroup.Item
                            key={childrenItem.id}
                            onClick={() => history.push(`${routes.group}/${childrenItem.id}`)}
                            style={{ cursor: 'pointer' }}
                        >
                            {childrenItem.name}
                        </ListGroup.Item>
                    );
                })}
                {group?.users?.map((childrenItem) => {
                    return (
                        <ListGroup.Item
                            key={childrenItem.id}
                            onClick={() => history.push(`${routes.user}/${childrenItem.id}`)}
                            style={{ cursor: 'pointer' }}
                        >
                            {childrenItem.name}
                        </ListGroup.Item>
                    );
                })}
            </ListGroup>
        </div>
    );
};
